import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import { apiFetch } from "../commons/axiosReq";
import "./Checkout.css";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const location = useLocation();
  const orderId = params.get("orderId") || "";
  const authority = params.get("Authority") || "";
  const status = params.get("Status") || "";
  const token = new Cookies().get("token");
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(true);
  const [error, setError] = useState("");
  const valid = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(orderId)
    && /^[AS][a-zA-Z0-9]{1,63}$/.test(authority);
  const check = useCallback(async (retry = false) => {
    if (!token || !valid) { setBusy(false); return; }
    setBusy(true);
    setError("");
    const saved = await apiFetch(`payment/orders/${orderId}`);
    if (!saved.ok) {
      setError(saved.error || "سفارش یافت نشد.");
    } else if (["Paid", "SandboxPaid"].includes(saved.data.status)) {
      setOrder(saved.data);
    } else if (status !== "OK" && !retry) {
      setError("پرداخت لغو شده یا ناموفق بوده است. اگر مبلغی کسر شده، دوباره وضعیت را بررسی کنید.");
    } else {
      const result = await apiFetch(`payment/orders/${orderId}/verify`, "post", { authority, status: "OK" });
      if (result.ok) setOrder(result.data);
      else setError(result.error || "تأیید پرداخت ممکن نشد. دوباره وضعیت را بررسی کنید.");
    }
    setBusy(false);
  }, [orderId, authority, status, token, valid]);
  useEffect(() => { check(); }, [check]);
  const paid = order?.status === "Paid";
  const sandboxPaid = order?.status === "SandboxPaid";
  return <main className="checkout-page" dir="rtl"><section className="checkout-success" aria-live="polite">
    <span>{paid || sandboxPaid ? <CheckCircle2 size={42} /> : <ShieldCheck size={42} />}</span>
    <h1>{!valid ? "لینک پرداخت معتبر نیست" : !token ? "ورود برای بررسی پرداخت" : busy ? "در حال بررسی پرداخت…" : paid ? "اشتراک شما فعال شد" : sandboxPaid ? "پرداخت آزمایشی تأیید شد" : "پرداخت تأیید نشده است"}</h1>
    {!token && valid && <><p>با همان حسابی که خرید را شروع کردید وارد شوید.</p><Link to={`/SignIn?redirect=${encodeURIComponent(location.pathname + location.search)}`}>ورود و بررسی پرداخت</Link></>}
    {(paid || sandboxPaid) && <>
      <p>{order.planTitle} — {new Intl.NumberFormat("fa-IR").format(order.amountToman)} تومان</p>
      <p>شماره پیگیری: {String(order.referenceId)}</p>
      {paid && order.subscriptionExpiresAt && <p>اعتبار تا {new Date(order.subscriptionExpiresAt).toLocaleDateString("fa-IR")}</p>}
      {sandboxPaid && <p>این تراکنش آزمایشی است و اشتراک واقعی فعال نشده است.</p>}
      <Link to="/user/dashboard">رفتن به پنل کاربری</Link>
    </>}
    {error && <p className="checkout-error" role="alert">{error}</p>}
    {token && valid && !paid && !sandboxPaid && !busy && <button className="payment-retry" onClick={() => check(true)}>بررسی دوباره وضعیت پرداخت</button>}
    {!paid && !sandboxPaid && !busy && <Link to="/#pricing">بازگشت به پلن‌ها</Link>}
  </section></main>;
}
